import React from 'react';

interface OdxTableCellProps {
    children: React.ReactNode,
    className?: string,
    style?: React.CSSProperties,
    key?: string
}

/**
 * @param children
 * @param style
 * @param className
 * @param rest
 */

export const OdxTableCell: React.FC<OdxTableCellProps> = ({key, children, style, className = "", ...rest}) => {
    return <td key={key} className={`odx-table__cell ${className}`} style={style} {...rest}>{children}</td>;
};